import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useMapStore = create()(persist((set) => ({
    center: [60.171006, 24.934051],
    zoom: 10,
    bounds: null,
    setCenter: (center) => set({ center }),
    setZoom: (zoom) => set({ zoom }),
    setBounds: (bounds) => set({ bounds }),
}), {
    name: 'citiguide-map-view',
    partialize: (state) => ({ center: state.center, zoom: state.zoom }),
}));
